import React, { useState, useEffect } from 'react';
import ModalA from '../components/ModalA';
import crazy from "../assets/images/crazyslotmonkey.jpg";

const Games = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [playerName, setPlayerName] = useState('');
  const [showNameInput, setShowNameInput] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [playerData, setPlayerData] = useState(null);

  // Generate random player names for the leaderboard
  const randomNames = [
    'SlotMaster', 'LuckySpinner', 'GoldenWheel', 'JackpotHunter', 'RoyalFlush',
    'SlotKing', 'CasinoQueen', 'LuckyCharm', 'HighRoller', 'WildWinner',
    'SpinDoctor', 'MoneyMaker', 'GoldRush', 'DiamondPlayer', 'VegasVIP',
    'JackpotJoy', 'AcesHigh', 'SpinWizard', 'RoyalGambler', 'LuckyStreak'
  ];

  // Initialize leaderboard and check for saved player
  useEffect(() => {
    // Check if we have a saved player
    const savedPlayer = sessionStorage.getItem('currentPlayer');
    let currentPlayerData = null;
    
    if (savedPlayer) {
      try {
        currentPlayerData = JSON.parse(savedPlayer);
        setPlayerData(currentPlayerData);
      } catch (e) {
        console.error('Error parsing saved player data', e);
      }
    }
    
    // Create a semi-random leaderboard
    const generateLeaderboard = () => {
      // Generate random players
      const randomPlayers = [];
      for (let i = 0; i < 15; i++) {
        const randomName = randomNames[Math.floor(Math.random() * randomNames.length)];
        const randomCoins = Math.floor(Math.random() * 99500) + 500;
        
        // Avoid duplicates
        if (!randomPlayers.some(p => p.name === randomName)) {
          randomPlayers.push({
            name: randomName,
            coins: randomCoins
          });
        }
      }
      
      // Add the current player if we have one
      if (currentPlayerData) {
        // Each visit, the player might gain some coins
        currentPlayerData.coins += Math.floor(Math.random() * 500);
        sessionStorage.setItem('currentPlayer', JSON.stringify(currentPlayerData));
        
        // Make sure the player isn't duplicated
        const existingIndex = randomPlayers.findIndex(p => p.name === currentPlayerData.name);
        if (existingIndex >= 0) {
          randomPlayers.splice(existingIndex, 1);
        }
        
        randomPlayers.push(currentPlayerData);
      }
      
      // Sort by coins and limit to top 10
      const newLeaderboard = randomPlayers
        .sort((a, b) => b.coins - a.coins)
        .slice(0, 10);
      
      setLeaderboard(newLeaderboard);
    };
    
    generateLeaderboard();
    
    // Simulate activity by updating scores periodically
    const activityInterval = setInterval(() => {
      setLeaderboard(prevLeaderboard => {
        const updatedLeaderboard = [...prevLeaderboard];
        
        // Update 1-3 random players
        const numUpdates = Math.floor(Math.random() * 3) + 1;
        
        for (let i = 0; i < numUpdates; i++) {
          const randomIndex = Math.floor(Math.random() * updatedLeaderboard.length);
          // Don't update the current player
          if (updatedLeaderboard[randomIndex].name !== currentPlayerData?.name) {
            const randomAmount = Math.floor(Math.random() * 300) - 50; // Can be negative sometimes
            updatedLeaderboard[randomIndex].coins += randomAmount;
            
            // Ensure coins don't go negative
            if (updatedLeaderboard[randomIndex].coins < 0) {
              updatedLeaderboard[randomIndex].coins = 50;
            }
          }
        }
        
        return updatedLeaderboard.sort((a, b) => b.coins - a.coins);
      });
    }, 8000);
    
    return () => clearInterval(activityInterval);
  }, []);

  const handleStartGame = () => {
    // If we already have player data, skip name input
    if (playerData) {
      setModalIsOpen(true);
    } else {
      setShowNameInput(true);
    }
  };

  const handleSubmitName = (e) => {
    e.preventDefault();
    if (playerName.trim()) {
      // Starting coins between 1000 and 2000
      const startingCoins = Math.floor(Math.random() * 1000) + 1000;
      
      // Create new player data
      const newPlayerData = { 
        name: playerName, 
        coins: startingCoins,
        joinedAt: new Date().toISOString()
      };
      
      // Save to session storage
      sessionStorage.setItem('currentPlayer', JSON.stringify(newPlayerData));
      setPlayerData(newPlayerData);
      
      // Update leaderboard with new player
      const updatedLeaderboard = [...leaderboard];
      const existingPlayerIndex = updatedLeaderboard.findIndex(p => p.name === playerName);
      
      if (existingPlayerIndex >= 0) {
        updatedLeaderboard[existingPlayerIndex] = newPlayerData;
      } else {
        updatedLeaderboard.push(newPlayerData);
      }
      
      // Sort and limit to top 10
      updatedLeaderboard.sort((a, b) => b.coins - a.coins);
      if (updatedLeaderboard.length > 10) {
        updatedLeaderboard.length = 10;
      }
      
      setLeaderboard(updatedLeaderboard);
      setShowNameInput(false);
      setModalIsOpen(true);
    }
  };

  return (
    <div className="games-page">
    <div className="container">
      <div className="games-header">
      <h1>Crazy Monkey Slot Game</h1>
<p>Play and compete against other players!</p>

        {playerData && (
          <div className="player-stats">
            <span className="player-welcome">Welcome back, {playerData.name}!</span>
            <span className="player-balance">Balance: <strong>{playerData.coins.toLocaleString()} Coins</strong></span>
          </div>
        )}
      </div>
  
      <div className="games-content">
        <div className="game-preview">
          <img src={crazy} alt="Crazy Monkey Kolikkopeli" className="game-preview__image" />
          <div className="game-preview__disclaimer">
          <p>Disclaimer: This is a free social casino game. <strong className='noreal'>No real money gambling.</strong></p>
<p>You must be at least 18 years old to play. Play responsibly.</p>

          </div>
          <button className="button button--primary" onClick={handleStartGame}>
            {playerData ?  'Continue Playing' : 'Play Now'}
          </button>
        </div>
  
        <div className="leaderboard">
          <h2>Top Players</h2>
          <div className="leaderboard-list">
            {leaderboard.length > 0 ? (
              leaderboard.map((player, index) => (
                <div key={index} className="leaderboard-item">
                  <span className="rank">#{index + 1}</span>
                  <span className="name">{player.name}</span>
                  <span className="coins">{player.coins.toLocaleString()} Coins</span>
                </div>
              ))
            ) : (
              <div className="leaderboard-empty">
                <p>No players yet. Be the first to play!</p>
              </div>
            )}
          </div>
        </div>
      </div>
  
      {showNameInput && (
        <div className="name-input-modal">
          <div className="name-input-content">
            <h2>Enter Your Name</h2>
            <form onSubmit={handleSubmitName}>
              <input
                type="text"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                placeholder="Nimesi"
                required
                maxLength={20}
              />
            <div className="name-input-disclaimer">
  <p>By entering your name, you confirm that you are at least 18 years old and accept the terms of service.</p>
</div>
<button type="submit" className="button button--primary">
  Start Game
</button>

            </form>
          </div>
        </div>
      )}
  
      {modalIsOpen && <ModalA setModalOpen={setModalIsOpen} />}
    </div>
  </div>
  
  );
};

export default Games;